module.exports = __webpack_public_path__ + "img/w_mockup_frame_6.d6097c07.png";